import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentManagementService } from "app/content-management/content-management.service";
import { ApiService } from "app/modules/shared/services/api.service";
import * as moment from "moment";
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import { TableComponent } from "../../table/table.component";
import * as _ from "underscore";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { AlertMessage } from "app/shared/utils/alertMessage";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AnalyticService } from "app/modules/shared/services/analytic.service";
import { UserData } from "app/shared/service/UserService";
import * as momenttz from "moment-timezone";
import { DateRangeComponent } from "../../date-range/date-range.component";
import { HelperService } from "app/modules/shared/services/helper.service";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import { CryptoService } from "app/shared/utils/crypto.service";
import { StarsLessonsUsageGraphAnalticsComponent } from "../../practice-set-analytics/stars-lessons-usage-graph-analtics/stars-lessons-usage-graph-analtics.component";

@Component({
  selector: 'app-members-tab-stars-lessons-analtics',
  templateUrl: './members-tab-stars-lessons-analtics.component.html',
  styleUrls: ['./members-tab-stars-lessons-analtics.component.scss']
})
export class MembersTabStarsLessonsAnalticsComponent {
  @ViewChild("starsLessonsUsageGraphAnalticsComponent") starsLessonsUsageGraphAnalticsComponent: StarsLessonsUsageGraphAnalticsComponent;
  @Input() selectedApp: any;
  @Input() dateData$: Subject<any>;
  @Input() practieSetName: string;
  @Input() userName: string;
  subscription: Subscription;
  subSink: Subscription;
  organizationId: any = "";
  userTimeZone: any;
  breadCrumb: any;
  breadCrumbUser: any;
  dataId: string;
  dateInfo: any;
  dateType: any = { type: "Month" };
  menuSelectedButton: any = "all";
  updateChart = false;
  startDate: any;
  endDate: any;
  date: any = {};
  today: any;
  listDateRange: any = "monthSelected";
  selectedDateForDay: any;
  sessionPlayedChartDatasets: Array<any> = [];
  sessionPlayedChartLabels: Array<any> = [];
  selectedMonth: any;
  sessionPlayedTab = "monthSelected";
  selectedYear: any;
  selectedEndDate: any;
  selectedFromDate: any;
  sessionDay: any = "";
  sessionMonth: any = "";
  sessionYear: any = "";
  sessionDateRange: any = "";
  toShowExpandText = false;
  last5Years = [];
  selectedSessionType: string;

  usageAnalyticsSelectedValue: string = "all";
  sessionDateRang: string = "";

  data = {
    id: undefined,
    name: undefined,
    username: null,
    userExists: false,
  };
  key: string;
  constructor(
    public analyticService: AnalyticService,
    public route: ActivatedRoute,
    public api: ApiService,
    public dialog: MatDialog,
    public router: Router,
    public contentManagementService: ContentManagementService,
    public fb: FormBuilder,
    public hs: HelperService,
    private crypto: CryptoService
  ) {
    this.organizationId = "noOrg";
    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != "") this.organizationId = UserData.organizationId;
    else if (!_.isUndefined(localStorage.getItem("organizationId"))) this.organizationId = localStorage.getItem("organizationId");
    this.organizationId = this.organizationId == null ? "noOrg" : this.organizationId;

    this.userTimeZone = momenttz().tz("America/New_York");
  }

  ngOnInit() {
    this.selectedApp = this.selectedApp == null ? JSON.parse(localStorage.getItem("selectedGame")) : this.selectedApp;
  }

  ngAfterViewInit() {
    this.subSink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      if (next) {
        this.dateInfo = localStorage.getItem("dateRange");
        if (this.dateInfo) {
          next = JSON.parse(this.dateInfo);
        }
        this.dateType = next;
        console.log(this.dateType);
        this.triggerDateSelection(next);
      }
    });
  }

  initiateDatePicker() {
    this.subscription = this.api.dateRange$.subscribe((v) => {
      if (v) this.triggerDateSelection(v);
    });
  }

  triggerDateSelection(data) {
    switch (data.type) {
      case "Day": {
        this.listDateRange = "daySelected";
        this.daySelected();
        break;
      }
      case "Month": {
        this.listDateRange = "monthSelected";
        this.monthSelected();
        break;
      }
      case "Year": {
        this.listDateRange = "yearSelected";
        this.yearSelected();
        break;
      }
      case "range": {
        this.listDateRange = "rangeSelected";
        this.rangeSelected(data);
        break;
      }
    }
  }

  daySelected() {
    this.toShowExpandText = false;
    this.sessionPlayedDaySelected("daySelected");

    // Set the calendar range to the last 31 days
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - 30);

    this.date = {
      startDate: startDate,
      endDate: currentDate,
    };
  }

  monthSelected() {
    this.toShowExpandText = false;
    // this.practiceSetSelected('monthSelected', '');
    this.sessionPlayedMonthSelected("monthSelected");
    // this.renderChartForSessionPlayedByMonth(this.selectedMonth);

    // Set the calendar range to show the last 2 years
    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    this.date = {
      startDate: twoYearsAgo,
      endDate: today,
    };
  }

  yearSelected() {
    // this.practiceSetSelected('yearSelected', '');
    this.sessionPlayedYearSelected("yearSelected");
    this.toShowExpandText = true;
    const today = new Date();
    const fourYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
    this.date = {
      startDate: fourYearsAgo,
      endDate: today,
    };
  }
  rangeSelected(result) {
    this.menuSelectedButton = "all";
    // this.usageAnalyticsSelectedValue = 'all';
    this.listDateRange = "rangeSelected";
    let startDate = moment(result.startDate).format("YYYY-MM-DD");
    let endDate = moment(result.endDate).format("YYYY-MM-DD");
    this.date = result;
    this.startDate = startDate;
    this.endDate = endDate;
    let dates = moment(result.startDate).format("YYYY-MM-DD") + " To " + moment(result.endDate).format("YYYY-MM-DD");
    this.getSessionDates(dates, "range");
    this.renderChartForSessionPlayedByDateRange(startDate, endDate);
  }

  sessionPlayedDaySelected(tab) {
    // this.usageAnalyticsSelectedValue = 'all';
    this.sessionPlayedTab = tab;
    this.menuSelectedButton = "all";
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    if (!this.selectedDateForDay) {
      this.selectedDateForDay = this.userTimeZone.format("YYYY-MM-DD");
    }
    this.getSessionDates(this.selectedDateForDay, "day");
    this.renderChartForSessionPlayedByDay(this.selectedDateForDay);
  }

  sessionPlayedMonthSelected(tab) {
    // this.usageAnalyticsSelectedValue = 'all';
    this.sessionPlayedTab = tab;
    this.menuSelectedButton = "all";
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    this.selectedMonth = this.today;
    this.getSessionDates(this.selectedMonth, "month");
    this.renderChartForSessionPlayedByMonth(this.selectedMonth);
  }

  sessionPlayedYearSelected(tab) {
    // this.usageAnalyticsSelectedValue = 'all';
    this.sessionPlayedTab = tab;
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    this.menuSelectedButton = "all";
    this.selectedYear = this.today;
    this.getSessionDates(this.selectedYear, "year");
    this.renderChartForSessionPlayedByYear(this.selectedYear);
  }

  async renderChartForSessionPlayedByDay(date, usageType?: string) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }
    this.analyticService.getSessionsPlayedByDay(date, this.selectedApp.id, nameStr, this.selectedApp.dataId, usageType).subscribe(
      (res) => {
        let dataList = res;
        this.sessionPlayedChartLabels = [];
        let totalSessionPlayedList = [];
        let totalSessionPlayedAvgDurationList = [];
        let totalUsersList = [];
        this.sessionDateRang = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (
            !_.isUndefined(dataList[0]["totalSessionPlayed"]) &&
            dataList[0]["totalSessionPlayed"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalPlayedSession" ||
              this.usageAnalyticsSelectedValue == "totalSessionPlayed" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayed = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedList = totalSessionPlayed.map((v) => Number(v));
          }

          if (
            !_.isUndefined(dataList[0]["totalSessionDurationAvg"]) &&
            dataList[0]["totalSessionDurationAvg"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "averageDuration" ||
              this.usageAnalyticsSelectedValue == "totalSessionDurationAvg" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayedAvgDuration = dataList[0]["totalSessionDurationAvg"];
            totalSessionPlayedAvgDurationList = totalSessionPlayedAvgDuration.map((v) => Number(v));
          }

          if (
            !_.isUndefined(dataList[0]["totalUsers"]) &&
            dataList[0]["totalUsers"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalUsers" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalUsers = dataList[0]["totalUsers"];
            totalUsersList = totalUsers.map((v) => Number(v));
          }

          if (nameStr != null) {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedList, label: "Total Sessions" },
              { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" }
            ];
          } else {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedList, label: "Total Sessions" },
              { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
              { data: totalUsersList, label: "Users" }
            ];
          }
          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
          } else {
            this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(date);
          }
          setTimeout((data: any) => {
            this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

            this.updateChart = true;
          }, 1000);
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }


  async renderChartForSessionPlayedByMonth(date, usageType?: string) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }

    this.analyticService.getSessionsPlayedByMonth(date, this.selectedApp.id, nameStr, this.selectedApp.dataId, usageType).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedMonthList = [];
        let totalSessionDurationAvgMonthsList = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        let totalUsersList = [];
        this.sessionDateRang = moment(new Date()).subtract(2, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (
            !_.isUndefined(dataList[0]["totalSessionPlayed"]) &&
            dataList[0]["totalSessionPlayed"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalPlayedSession" ||
              this.usageAnalyticsSelectedValue == "totalSessionPlayed" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayedMonth = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedMonthList = totalSessionPlayedMonth.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalSessionDurationAvg"]) &&
            dataList[0]["totalSessionDurationAvg"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "averageDuration" ||
              this.usageAnalyticsSelectedValue == "totalSessionDurationAvg" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionDurationAvgMonths = dataList[0]["totalSessionDurationAvg"];
            totalSessionDurationAvgMonthsList = totalSessionDurationAvgMonths.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalUsers"]) &&
            dataList[0]["totalUsers"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalUsers" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalUsers = dataList[0]["totalUsers"];
            totalUsersList = totalUsers.map((v) => Number(v));
          }

          if (nameStr != null) {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedMonthList, label: "Total Sessions" },
              { data: totalSessionDurationAvgMonthsList, label: "Average Session Duration" }
            ];
          } else {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedMonthList, label: "Total Sessions" },
              { data: totalSessionDurationAvgMonthsList, label: "Average Session Duration" },
              { data: totalUsersList, label: "Users" }
            ];
          }

          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
          } else {
            this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(date);
          }

          this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

          this.updateChart = true;
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async renderChartForSessionPlayedByYear(date, usageType?: string) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }
    this.analyticService.getSessionsPlayedByYear(date, this.selectedApp.id, nameStr, this.selectedApp.dataId, usageType).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedYearList = [];
        let totalSessionDurationAvgYearsList = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        let totalUsersList = [];
        this.sessionDateRang = moment(new Date()).subtract(4, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (
            !_.isUndefined(dataList[0]["totalSessionPlayed"]) &&
            dataList[0]["totalSessionPlayed"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalPlayedSession" ||
              this.usageAnalyticsSelectedValue == "totalSessionPlayed" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalSessionDurationAvg"]) &&
            dataList[0]["totalSessionDurationAvg"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "averageDuration" ||
              this.usageAnalyticsSelectedValue == "totalSessionDurationAvg" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionDurationAvgYear = dataList[0]["totalSessionDurationAvg"];
            totalSessionDurationAvgYearsList = totalSessionDurationAvgYear.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalUsers"]) &&
            dataList[0]["totalUsers"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalUsers" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalUsers = dataList[0]["totalUsers"];
            totalUsersList = totalUsers.map((v) => Number(v));
          }
          if (nameStr != null) {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedYearList, label: "Total Sessions" },
              { data: totalSessionDurationAvgYearsList, label: "Average Session Duration" }
            ];
          } else {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedYearList, label: "Total Sessions" },
              { data: totalSessionDurationAvgYearsList, label: "Average Session Duration" },
              { data: totalUsersList, label: "Users" }
            ];
          }

          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = timepointPlayed;
          } else {
            this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(date);
          }

          this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

          this.updateChart = true;
          if (timepointPlayed) {
            this.last5Years = timepointPlayed;
          } else {
            this.last5Years = this.getLastFiveYearsDefault(date);
          }
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async renderChartForSessionPlayedByDateRange(fromDate, toDate, usageType?: any) {
    this.updateChart = false;
    // this.usageAnalyticsSelectedValue = 'all';
    this.menuSelectedButton = "all";
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }
    this.analyticService.getSessionsPlayedByDateRange(fromDate, toDate, this.selectedApp.id, nameStr, this.selectedApp.dataId, usageType).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedYearList = [];
        let totalSessionPlayedAvgDurationYearList = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        let totalUsersList = [];
        this.sessionDateRang = moment(fromDate).format("MM/DD/YYYY") + " - " + moment(toDate).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (
            !_.isUndefined(dataList[0]["totalSessionPlayed"]) &&
            dataList[0]["totalSessionPlayed"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalPlayedSession" ||
              this.usageAnalyticsSelectedValue == "totalSessionPlayed" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalSessionDurationAvg"]) &&
            dataList[0]["totalSessionDurationAvg"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "averageDuration" ||
              this.usageAnalyticsSelectedValue == "totalSessionDurationAvg" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalSessionPlayedAvgDurationYear = dataList[0]["totalSessionDurationAvg"];
            totalSessionPlayedAvgDurationYearList = totalSessionPlayedAvgDurationYear.map((v) => Number(v));
          }
          if (
            !_.isUndefined(dataList[0]["totalUsers"]) &&
            dataList[0]["totalUsers"].length != 0 &&
            (this.usageAnalyticsSelectedValue == "totalUsers" || this.usageAnalyticsSelectedValue == "all")
          ) {
            let totalUsers = dataList[0]["totalUsers"];
            totalUsersList = totalUsers.map((v) => Number(v));
          }
          if (nameStr != null) {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedYearList, label: "Total Sessions" },
              { data: totalSessionPlayedAvgDurationYearList, label: "Average Session Duration" }
            ];
          } else {
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedYearList, label: "Total Sessions" },
              { data: totalSessionPlayedAvgDurationYearList, label: "Average Session Duration" },
              { data: totalUsersList, label: "Users" }
            ];
          }

          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
          } else {
            this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(fromDate, toDate);
          }

          this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

          this.updateChart = true;
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async averageDuration(buttonValue) {
    this.updateChart = false;
    this.menuSelectedButton = "";
    this.menuSelectedButton = buttonValue;
    this.sessionPlayedChartDatasets = [];
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }
    if (this.listDateRange === "daySelected") {
      if (!this.selectedDateForDay) {
        this.selectedDateForDay = this.userTimeZone.format("YYYY-MM-DD");
      }
      this.analyticService.getSessionsPlayedByDay(this.selectedDateForDay, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedAvgDurationList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
              let totalSessionPlayedAvgDuration = dataList[0]["totalSessionDurationAvg"];
              totalSessionPlayedAvgDurationList = totalSessionPlayedAvgDuration.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.selectedDateForDay);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "monthSelected") {
      this.analyticService.getSessionsPlayedByMonth(this.selectedMonth, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionDurationAvgMonthsList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
              let totalSessionDurationAvgMonths = dataList[0]["totalSessionDurationAvg"];
              totalSessionDurationAvgMonthsList = totalSessionDurationAvgMonths.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionDurationAvgMonthsList, label: "Average Session Duration" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.selectedMonth);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "yearSelected") {
      this.analyticService.getSessionsPlayedByYear(this.selectedYear, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionDurationAvgYearsList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
              let totalSessionDurationAvgYear = dataList[0]["totalSessionDurationAvg"];
              totalSessionDurationAvgYearsList = totalSessionDurationAvgYear.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionDurationAvgYearsList, label: "Average Session Duration" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = timepointPlayed;
              } else {
                this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.selectedYear);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else {
      this.analyticService.getSessionsPlayedByDateRange(this.startDate, this.endDate, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedAvgDurationYearList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(this.startDate).format("MM/DD/YYYY") + " - " + moment(this.endDate).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
              let totalSessionPlayedAvgDurationYear = dataList[0]["totalSessionDurationAvg"];
              totalSessionPlayedAvgDurationYearList = totalSessionPlayedAvgDurationYear.map((v) => Number(v));


              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedAvgDurationYearList, label: "Average Session Duration" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(this.startDate, this.endDate);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    }
  }

  totalUsersSession(buttonValue) {
    this.updateChart = false;
    this.menuSelectedButton = "";
    this.menuSelectedButton = buttonValue;
    this.sessionPlayedChartDatasets = [];

    if (this.listDateRange === "daySelected") {
      if (!this.selectedDateForDay) {
        this.selectedDateForDay = this.userTimeZone.format("YYYY-MM-DD");
      }
      this.analyticService.getSessionsPlayedByDay(this.selectedDateForDay, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalUsersList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalUsers"]) && dataList[0]["totalUsers"].length != 0) {
              let totalUsers = dataList[0]["totalUsers"];
              totalUsersList = totalUsers.map((v) => Number(v));
              this.sessionPlayedChartDatasets = [{ data: totalUsersList, label: "Users" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.selectedDateForDay);
              }
              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "monthSelected") {
      this.analyticService.getSessionsPlayedByMonth(this.selectedMonth, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalUsersList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalUsers"]) && dataList[0]["totalUsers"].length != 0) {
              let totalUsers = dataList[0]["totalUsers"];
              totalUsersList = totalUsers.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalUsersList, label: "Users" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.selectedMonth);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "yearSelected") {
      this.analyticService.getSessionsPlayedByYear(this.selectedYear, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalUsersList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalUsers"]) && dataList[0]["totalUsers"].length != 0) {
              let totalUsers = dataList[0]["totalUsers"];
              totalUsersList = totalUsers.map((v) => Number(v));
              this.sessionPlayedChartDatasets = [{ data: totalUsersList, label: "Users" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = timepointPlayed;
              } else {
                this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.selectedYear);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else {
      this.analyticService.getSessionsPlayedByDateRange(this.startDate, this.endDate, this.selectedApp.id, null, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalUsersList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(this.startDate).format("MM/DD/YYYY") + " - " + moment(this.endDate).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalUsers"]) && dataList[0]["totalUsers"].length != 0) {
              let totalUsers = dataList[0]["totalUsers"];
              totalUsersList = totalUsers.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalUsersList, label: "Users" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(this.startDate, this.endDate);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    }
  }

  async totalPlayedSession(buttonValue) {
    this.updateChart = false;
    this.menuSelectedButton = "";
    this.menuSelectedButton = buttonValue;
    this.sessionPlayedChartDatasets = [];
    let nameStr = null;

    if (this.userName) {
      nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    }
    if (this.listDateRange === "daySelected") {
      if (!this.selectedDateForDay) {
        this.selectedDateForDay = this.userTimeZone.format("YYYY-MM-DD");
      }
      this.analyticService.getSessionsPlayedByDay(this.selectedDateForDay, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
              let totalSessionPlayed = dataList[0]["totalSessionPlayed"];
              totalSessionPlayedList = totalSessionPlayed.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedList, label: "Total Sessions" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.selectedDateForDay);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "monthSelected") {
      this.analyticService.getSessionsPlayedByMonth(this.selectedMonth, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedMonthList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
              let totalSessionPlayedMonth = dataList[0]["totalSessionPlayed"];
              totalSessionPlayedMonthList = totalSessionPlayedMonth.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedMonthList, label: "Total Sessions" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.selectedMonth);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else if (this.listDateRange === "yearSelected") {
      this.analyticService.getSessionsPlayedByYear(this.selectedYear, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedYearList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
              let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
              totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedYearList, label: "Total Sessions" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = timepointPlayed;
              } else {
                this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.selectedYear);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } else {
      this.analyticService.getSessionsPlayedByDateRange(this.startDate, this.endDate, this.selectedApp.id, nameStr, this.selectedApp.dataId).subscribe(
        (res) => {
          let dataList = res;
          let totalSessionPlayedYearList = [];
          this.sessionPlayedChartDatasets = [];
          this.sessionPlayedChartLabels = [];
          this.sessionDateRang = moment(this.startDate).format("MM/DD/YYYY") + " - " + moment(this.endDate).format("MM/DD/YYYY");
          if (!_.isUndefined(dataList)) {
            if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
              let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
              totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));

              this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedYearList, label: "Total Sessions" }];

              const timepointPlayed = dataList?.[0]?.["Timepoint"];
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(this.startDate, this.endDate);
              }

              this.starsLessonsUsageGraphAnalticsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);

              this.updateChart = true;
            }
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    }
  }

  getLastThirtyDaysDefault(date) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(date);
    for (var i = 0; i <= 30; i++) {
      var selectedDate = new Date(anchorDate);
      selectedDate.setDate(selectedDate.getDate() - i);
      daysDate.push(moment(selectedDate).format("ddd, MMM D"));
    }
    return daysDate.reverse();
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, "months");
      months.push(moment(selectedMonth).format("MMM YYYY"));
    }
    return months.reverse();
  }

  getLastFiveYearsDefault(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, "years");
      years.push(moment(selectedYear).format("YYYY"));
    }
    return years.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }
  
  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1);
  
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      });
  }
  
  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, day, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1, day);
  
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
      });
  }

  getSessionDates(data, tab) {
    this.sessionDay = "";
    this.sessionMonth = "";
    this.sessionYear = "";
    this.sessionDateRange = "";
    if (tab == "day") this.sessionDay = data;
    else if (tab == "month") this.sessionMonth = moment(data).format("MMMM YYYY");
    else if (tab == "year") this.sessionYear = moment(data).format("YYYY");
    else if (tab == "range") this.sessionDateRange = data;
  }

  changeAnalytics(value) {
    this.usageAnalyticsSelectedValue = value;
    this.selectedSessionType = value;
    if (value == "totalPlayedSession") this.totalPlayedSession("totalPlayedSession");
    else if (value == "totalSessionPlayed") this.totalPlayedSession("totalSessionPlayed");
    else if (value == "totalSessionDurationAvg") this.averageDuration("totalSessionDurationAvg");
    else if (value == "averageDuration") this.averageDuration("averageDuration");
    else if (value == "totalUsers") this.totalUsersSession("totalUsers");
    else if (value == "all") {
      this.menuSelectedButton = "all";
      if (this.listDateRange == "daySelected") {
        if (!this.selectedDateForDay) {
          this.selectedDateForDay = this.userTimeZone.format("YYYY-MM-DD");
        }
        this.renderChartForSessionPlayedByDay(this.selectedDateForDay);
      } else if (this.listDateRange == "monthSelected") {
        this.renderChartForSessionPlayedByMonth(this.selectedMonth);
      } else if (this.listDateRange == "yearSelected") {
        this.renderChartForSessionPlayedByYear(this.selectedYear);
      } else {
        this.renderChartForSessionPlayedByDateRange(this.startDate, this.endDate);
      }
    }

  }

  async exportCsvData(analyticsType) {
    let dateType;
    if (this.listDateRange == "daySelected") dateType = "day";
    else if (this.listDateRange == "monthSelected") dateType = "month";
    else if (this.listDateRange == "yearSelected") dateType = "year";
    else if (this.listDateRange == "rangeSelected") {
      dateType = "range";
    }
    let requestParam = "";
    if (analyticsType === "usage" && !_.isUndefined(this.selectedSessionType) && this.selectedSessionType != "all") {
      let selectedSessionType: any;

      if (this.selectedSessionType === "averageDuration") {
        selectedSessionType = "totalSessionDurationAvg";
      } else if (this.selectedSessionType === "masteredPracticeSets") {
        selectedSessionType = "totalSessionMastered";
      } else if (this.selectedSessionType === "incorrectSession") {
        selectedSessionType = "incorrectSession";
      } else if (this.selectedSessionType === "totalSessionDurationAvg") {
        selectedSessionType = "totalSessionDurationAvg";
      } else if (this.selectedSessionType === "totalUsers") {
        selectedSessionType = "totalUsers";
      } else {
        selectedSessionType = "totalSessionPlayed";
      }

      requestParam = selectedSessionType ? "&selectedUsageType=" + selectedSessionType : "";
      if (this.selectedApp.title == "Basic Vectoring" || this.selectedApp.title == "Advanced Vectoring") {
        requestParam = "&selectedUsageType=" + this.usageAnalyticsSelectedValue;
      }
    }
    try {
      let nameStr = null;

      if (this.userName) {
        nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
      }
      this.analyticService.getCsvData(analyticsType, dateType, this.startDate, this.endDate, this.selectedApp.id, requestParam, nameStr, this.selectedApp.dataId).subscribe(
        (data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } catch (error) { }
  }

  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    //this.api.changeMessage({ type: "Day" });
    if (this.subSink) {
      this.subSink.unsubscribe();
    }
  }

}
